import { DataObjectView } from '@atlas-frontend/sdk';
import { DataObjectEdit } from '../data-objects/DataObjectEdit';
import { useDataObjectActionHandlers } from '../data-objects/useDataObjectActionHandlers';
import { OUTPUT_DATA_OBJECT_ROUTES } from './OutputDataObjects';

export const OutputDataObjectEdit = () => {
  const { handleCancel } = useDataObjectActionHandlers('outputDataObjectView');

  return (
    <DataObjectEdit
      routes={OUTPUT_DATA_OBJECT_ROUTES}
      view={DataObjectView.OUT}
      onCancel={handleCancel}
    />
  );
};
